export const MEASUREMENT_LABELS: Record<string, string> = {
    w: '% Vesipitoisuus',
    Hu: '% Humuspitoisuus',
    VG: 'kN/m³ Tilavuuspaino',
    Rs: 't/m³ Kiintotiheys',
    n: 'Huokoisuus',
    e: 'Huokosluku',
    Sr: '% Kyllästysaste',
    D: '% Tiiviyaste',
    Wp: '% Kieritysraja',
    Wl: '% Juoksuraja',
    Ip: 'Plastisuusluku',
    k: 'm/s Vedenläpäisevyys',
    Hc: 'm Kapillaarinen nousukorkeus',
    d10: 'Tehokas raekoko d10',
    U: 'Tasaisuusluku d60:d10',
    KIRK: 'Kivinäyte rakeisuus',
    KIRs: 't/m³ Kivinäyte kiintotiheys',
    KIR: 't/m³ Kivinäyte irtotiheys',
    KIHu: '% Kivinäyte humuspitoisuus',
    KILP: '% Kivinäyte lietepitoisuus',
    KIS: 'Kivinäyte muotoarvo',
    KILA: 'Kivinäyte Los Angeles-luku',
    KIHA: 'Kivinäyte parannettu haurausarvo',
    KIHI: 'cm³ Kivinäyte hioutuvuusluku',
    KIMP: 'Kivinäyte murtopintaluku',
    m1: 'Moduuliluku normaalisti konsolidoitunut',
    m2: 'Moduuliluku, ylikonsolidoitunut',
    bet1: 'Jännityseksponentti, normaalisti konsolidoitunut maakerros',
    bet2: 'Jännityseksponentti, ylikonsolidoitunut maakerros',
    cv: 'm²/a Konsolidaatiokerroin vertikaalinen',
    ch: 'm²/a Konsolidaatiokerroin horisontaalinen',
    F: '% Hienousluku',
    sk: 'kPa Leikkauslujuus, kartiokoe',
    St: 'Sensitiivisyys',
    sp: 'kPa Leikkauslujuus, puristuskoe',
    rak: 'Rakeisuus',
    R: '(t/m³) Irtotiheys',
    Rd: '(t/m³) Kuivatiheys',
    Vd: '(kN/m³) Kuivatilavuus paino',
    Dr: 'Suhteellinen tiiviyjs',
    Ph: 'Ph-arvo',
    So: '(kN/m²) Vallitseva jännitys',
    Sc: '(kN/m²) Konsolidaatio jännitys',
    Mv: '(m²/MN) Kokoonpuristuvuuskerroin',
    M: '(MN/m²) Kokoonpuristuvuusmoduuli',
    Cc: 'Kokoonpuristuvuusindeksi',
    P: 'Poissonin luku',
    A: 'Huokospaine parametri',
    B: 'Huokospaine parametri',
} as const;

export const SURVEY_TYPE_TITLES: Record<string, string> = {
    SI: 'Siipikairaus',
    FVT: 'Siipikairaus',
    PA: 'Painokairaus',
    WST: 'Painokairaus',
    PI: 'Pistokairaus',
    LY: 'Lyöntikairaus',
    HE: 'Heijarikairaus',
    DP: 'Heijarikairaus',
    PT: 'Putkikairaus',
    TR: 'Tärykairaus',
    PR: 'Puristinkairaus',
    HU: 'Huokosilmaputki',
    CP: 'Puristinkairaus(CPT)',
    CPT: 'Puristinkairaus(CPT)',
    CU: 'Huokospainekairaus(CPTU)',
    CPTU: 'Huokospainekairaus(CPTU)',
    HP: 'Puristin-heijari -kairaus',
    PO: 'Porakonekairaus',
    MW: 'MWD-kairaus',
    VP: 'Pohjaveden mittausputki',
    VO: 'Orsiveden mittausputki',
    VK: 'Vedenpinnan mittaus kaivosta',
    HV: 'Kalliopohjavesiputki',
    PS: 'Pressometrikoe',
    PMT: 'Pressometrikoe',
    PM: 'Painumamittaus',
    KO: 'Koekuoppa',
    KE: 'Kallionäytekairaus',
    HK: 'Heijarikairaus vääntömomentilla',
    NO: 'Näytteenotto häiritty',
    NE: 'Näytteenotto häiriintymätön',
} as const;

export const DASH_PATTERNS = {
    SOLID: undefined,
    DASHED: [5, 5],
    DOTTED: [2, 3],
    DASH_DOT: [8, 3, 2, 3],
    LONG_DASH: [10, 5],
    SHORT_DASH: [3, 3],
    DASH_DOT_DOT: [8, 3, 2, 3, 2, 3],
    SPARSE_DOT: [2, 8],
    DENSE_DASH: [4, 2],
    VARIED: [12, 3, 3, 3],
} as const;

export const DASH_PATTERNS_ARRAY = [
    DASH_PATTERNS.SOLID,
    DASH_PATTERNS.DASHED,
    DASH_PATTERNS.DOTTED,
    DASH_PATTERNS.DASH_DOT,
    DASH_PATTERNS.LONG_DASH,
    DASH_PATTERNS.SHORT_DASH,
    DASH_PATTERNS.DASH_DOT_DOT,
    DASH_PATTERNS.SPARSE_DOT,
    DASH_PATTERNS.DENSE_DASH,
    DASH_PATTERNS.VARIED,
] as const;

export const GRAY = '#ddd';

export const GRID_LINE_WIDTH = 0.5;
